import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, computed, inject } from '@angular/core';

import { CommunityJoinVm, CommunityPalette, getCommunityPalette } from '../health-nav.models';
import { CategoriesStore } from '@state/categories.store';

@Component({
  selector: 'app-community-join-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './community-join-card.component.html',
  styleUrls: ['./community-join-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunityJoinCardComponent {
  private readonly categoriesStore = inject(CategoriesStore);

  @Input({ required: true }) community!: CommunityJoinVm;
  @Input() starterPosts: string[] = [];
  @Output() join = new EventEmitter<void>();

  readonly isJoined = computed(() => {
    const id = Number(String(this.community?.communityId ?? '').trim());
    if (!Number.isFinite(id)) {
      return false;
    }

    return Boolean(this.categoriesStore.getById(id)?.isFollowing);
  });

  get palette(): CommunityPalette {
    return getCommunityPalette(this.community?.communityId);
  }

  get filteredStarterPosts(): string[] {
    const reason = this.normalizeText(this.community?.description ?? '');
    const seen = new Set<string>();

    return this.starterPosts.filter(item => {
      const normalized = this.normalizeText(item);
      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);

      if (!reason) {
        return true;
      }

      return normalized !== reason && !reason.includes(normalized) && !normalized.includes(reason);
    });
  }

  private normalizeText(value: string): string {
    return value
      .trim()
      .toLowerCase()
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, ' ');
  }
}
